import { extend } from 'flarum/common/extend';
import TextEditor from 'flarum/common/components/TextEditor';
import Button from 'flarum/common/components/Button';
import app from 'flarum/common/app';

export default function () {
  extend(TextEditor.prototype, 'oninit', function () {
    this.uploadMdFile = () => {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = '.md,.markdown';
      input.style.display = 'none';

      input.onchange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (event) => {
          const content = event.target.result;

          // 提取标题
          const titleMatch = content.match(/^\s*#\s+(.+)$/m);
          const title = titleMatch ? titleMatch[1].trim() : '';

          // 获取编辑器实例
          const editor = this.attrs.composer.editor;
          
          // 如果有标题字段，设置标题
          if (this.attrs.composer.fields && this.attrs.composer.fields.title && title) {
            this.attrs.composer.fields.title(title);
          }

          // 设置内容到编辑器
          if (editor && typeof editor.setValue === 'function') {
            editor.setValue(content);
          } else if (this.attrs.composer.fields && this.attrs.composer.fields.content) {
            this.attrs.composer.fields.content(content);
          }
          
          // 触发重绘
          m.redraw();
        };
        reader.readAsText(file);
      };

      document.body.appendChild(input);
      input.click();
      document.body.removeChild(input);
    };
  });

  extend(TextEditor.prototype, 'controlItems', function (items) {
    items.add(
      'uploadMd',
      <Button
        icon="fas fa-file-import"
        onclick={this.uploadMdFile.bind(this)}
        title="上传 Markdown 文件"
        className="Button Button--icon Button--link hasIcon"
      >
        上传 MD
      </Button>,
      10
    );
  });
}
